export type GoogleChatCacheEntityType = 'SPACE' | 'MEMBER';
export type GoogleChatCacheEntityId = `${GoogleChatCacheEntityType}#${string}`;

export enum GoogleChatSpaceType {
  DIRECT_MESSAGE = 'DIRECT_MESSAGE',
  SPACE = 'SPACE',
  GROUP_CHAT = 'GROUP_CHAT',
}

export const GOOGLE_CHAT_CONVERSATION_SPACE_TYPES: ReadonlySet<GoogleChatSpaceType> =
  new Set([GoogleChatSpaceType.DIRECT_MESSAGE, GoogleChatSpaceType.GROUP_CHAT]);

export interface GoogleChatCacheKeys {
  accountKey: string; // PK — subscriber gmailAddress
  entityId: GoogleChatCacheEntityId; // SK — "SPACE#<space.name>" | "MEMBER#<memberId>"
}

export interface GoogleChatCacheFields {
  entityType: GoogleChatCacheEntityType;
  resourceId: string; // space.name | member.name | email
  refreshedAt: number; // unix-ms TTL marker

  // SPACE fields (present when entityType === 'SPACE')
  spaceDisplayName?: string;
  spaceType?: GoogleChatSpaceType;
  memberIds?: string[]; // list of people/<id> strings

  // MEMBER fields
  email?: string;
  displayName?: string;
  avatarUrl?: string;
  userId?: string; // Clerk user id when resolvable
  isBot?: boolean;
}

export interface GoogleChatCacheItem
  extends GoogleChatCacheKeys,
    GoogleChatCacheFields {}

export interface GoogleChatUserDetailsResult {
  memberId: string;
  email: string;
  displayName: string;
  userId: string;
  avatarUrl?: string;
  isBot?: boolean;
  refreshedAt?: number;
}
